"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

export function usePathnameChange(callback: () => void) {
	const pathname = usePathname();

	// biome-ignore lint/correctness/useExhaustiveDependencies: NextJS recommended way to listen to route changes
	useEffect(() => {
		callback();
	}, [pathname]);
}

export function useRouteChange(callback: () => void) {
	const pathname = usePathname();
	const searchParams = useSearchParams();

	// biome-ignore lint/correctness/useExhaustiveDependencies: NextJS recommended way to listen to route changes
	useEffect(() => {
		callback();
	}, [pathname, searchParams]);
}
